import {useCallback, useEffect, useState} from 'react';
import {Keyboard} from 'react-native';

import {white} from '/theme/color/on.color';
import {alto} from '/theme/color/secondary.color';

import {reasonCodes} from './DeclineReasonPopover';

export const useDeclineReasonPopover = ({declineReasonCodes}: any) => {
  const [otherReasonSelected, setOtherReasonSelected] = useState(false);
  const [otherReasonInput, setOtherReasonInput] = useState('');
  const [declineReasons, setDeclineReasons] = useState<reasonCodes[]>([]);

  const handleBackgroundColorChange = (id: any) => {
    return declineReasons
      ?.filter((reason: any) => reason?.reasonTypeId === id)
      ?.find((reason: any) => reason?.isSelected === true)
      ? alto
      : white;
  };

  const handleReasonSelect = useCallback(
    id => {
      Keyboard.dismiss();
      const updatedReasons = declineReasons?.map((obj: any) =>
        obj?.reasonTypeId === id
          ? {...obj, isSelected: true}
          : {...obj, isSelected: false},
      );
      setDeclineReasons(updatedReasons);
      if (id === 'RD4') {
        setOtherReasonSelected(true);
      } else {
        setOtherReasonSelected(false);
      }
    },
    [declineReasons],
  );

  const handleOtherReasonInputChange = (txt: string) => {
    setOtherReasonInput(txt);
    const updatedReasons = declineReasons.map((obj: any) =>
      obj.reasonTypeId === 'RD4' ? {...obj, otherReason: txt} : obj,
    );
    setDeclineReasons(updatedReasons);
  };

  useEffect(() => {
    if (declineReasonCodes?.length > 0) {
      const updatedDeclineReasons = declineReasonCodes?.map((reasons: any) => ({
        ...reasons,
        isSelected: false,
      }));
      setDeclineReasons(updatedDeclineReasons);
    }
  }, [declineReasonCodes]);

  return {
    otherReasonSelected,
    otherReasonInput,
    declineReasons,
    handleReasonSelect,
    handleOtherReasonInputChange,
    handleBackgroundColorChange,
  };
};
